module.exports = __webpack_public_path__ + "assets/img/28_1063_big.333316d2.jpg";